import { ComponentPropsWithRef, ForwardedRef } from "react";
import { container } from "./style";

export interface ContainerProps extends ComponentPropsWithRef<"div"> {
  forwardRef?: ForwardedRef<HTMLDivElement>;
}

export const Container = ({
  children,
  forwardRef,
  ...props
}: ContainerProps) => {
  return (
    <div css={container} ref={forwardRef} {...props}>
      {children}
    </div>
  );
};
